module.exports = __webpack_public_path__ + "img/k8s-b.cb4a3771.svg";